import { render, staticRenderFns } from "./WebsiteProjects.vue?vue&type=template&id=ae8ed9b8&scoped=true&"
import script from "./WebsiteProjects.vue?vue&type=script&lang=js&"
export * from "./WebsiteProjects.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteProjects.vue?vue&type=style&index=0&id=ae8ed9b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8ed9b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VSpacer,VToolbar,VToolbarTitle})
